// function to handle SSN validation for accessible forms
// result carries a "code" that maps to an l10n  "invalid-feedback[data-error-code]" container in the view.
//
// shared by form_validation_controller (consumer sign-up) and family_information_controller (QHP applicant)
export const SSN_CODES = { CONFLICT: 'ssn_conflict', REQUIRED: 'ssn_required' }

// digits        - ssn digits already stripped of non-numeric characters (e.g. "123456789")
// noSsn         - state of the "I don't have an SSN" checkbox
// hasStoredSsn  - an SSN is already on file (masked facade present) — skip validation
// returns { valid, target, code } where target is 'ssn' | 'noSsn' | null
export function validateSsn({ digits = "", noSsn = false, hasStoredSsn = false } = {}) {
  if (hasStoredSsn) return { valid: true, target: null, code: null }
  if (noSsn && digits.length > 0) return { valid: false, target: "noSsn", code: SSN_CODES.CONFLICT }
  if (!noSsn && digits.length === 0) return { valid: false, target: "ssn", code: SSN_CODES.REQUIRED }
  return { valid: true, target: null, code: null }
}
